import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Table, {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from 'material-ui/Table'
import Select from 'material-ui/Select'

import { saveStep, save_Education_Data, savePopCount } from './actions'

class Question5 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popCount: 'Loading...',
      current_level: '',
      education: this.props.education,
      page: 0,
      rowsPerPage: 5,
      showPopulation: false,
      popLoaded: false,
      levels: [
        'Everyone',
        'High School or above',
        'Some College or above',
        'Associate Degree or above',
        'Bachelor Degree or above',
        'Graduate Degree or above',
        'PHD / Post Doctoral'
      ]
    }
  }

  componentDidMount() {
    this.setState({
      current_level: this.state.levels[this.props.education]
    })
  }

  async getDistribution() {
    let education = -1
    if (this.state.education > 0) {
      education = this.state.education
    }

    this.setState({
      popCount: 'Loading...',
      popLoaded: false
    })

    //  alert('https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/'+this.props.pref_fans+'/clrhigh/5/clrlow/1/education/'+this.props.education+'/income/'+this.props.income+'/cust/2');
    let currentComponent = this

    // Get Population Count
    //alert('https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/50/herprefans/0/clrhigh/5/clrlow/1/education/'+this.props.education+'/income/'+this.props.income+'/cust/2');
    //alert('https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/1/agehigh/'+this.state.oldest+'/agelow/'+this.state.youngest+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/50/herprefans/0/clrhigh/5/clrlow/1')
    //alert('https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/0/clrhigh/5/clrlow/1/education/'+this.state.education+'/income/'+this.props.income+'/cust/2')
    await axios({
      method: 'get',
      //url: 'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/52/agelow/45/oarhigh/10/oarlow/9/herprefage/55/herprefans/0/clrhigh/5/clrlow/1/education/0/income/0/cust/2',
      url:
        'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
        this.props.agehigh +
        '/agelow/' +
        this.props.agelow +
        '/oarhigh/' +
        this.props.oarhigh +
        '/oarlow/' +
        this.props.oarlow +
        '/herprefage/' +
        this.props.old_age +
        '/herprefans/' +
        this.props.pref_fans +
        '/clrhigh/5/clrlow/1/education/' +
        education +
        '/income/-1/cust/' +
        this.props.customer_number
    }).then(function(response) {
      if (response.data[0]['SearchCount']) {
        currentComponent.setState({
          popCount: response.data[0]['SearchCount'],
          popLoaded: true
        })
      } else {
        currentComponent.getDistribution()
      }
    })
  }

  handleChange = event => {
    this.props.save_Education_Data(
      this.state.levels.indexOf(event.target.value)
    )
    //alert(this.state.levels.indexOf(event.target.value))
    //alert(event.target.value)

    if (this.state.levels.indexOf(event.target.value) == 0) {
      this.setState(
        {
          current_level: event.target.value,
          education: -1
        },
        function() {
          if (this.state.showPopulation) {
            this.getDistribution()
          }
        }
      )
    } else {
      this.setState(
        {
          current_level: event.target.value,
          education: this.state.levels.indexOf(event.target.value)
        },
        function() {
          if (this.state.showPopulation) {
            this.getDistribution()
          }
        }
      )
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }

  onShowPopulation = () => {
    this.getDistribution()
    this.setState({
      showPopulation: true
    })
  }

  onNext() {
    if (this.state.popLoaded) {
      this.props.savePopCount(this.state.popCount)
      this.props.saveStep()
      this.props.changeRoute(
        '/console/search/create_new_search/six_basic_filters/question6'
      )
    } else {
      alert('Please wait for the population count to load before proceeding.')
    }
  }

  render() {
    const { classes, theme, location } = this.props
    const { rowsPerPage, page, showPopulation } = this.state

    if (this.props.step < 4) {
      alert(
        'You cannot skip steps. Please go through creating the search one step at a time.'
      )
      this.props.changeRoute(
        '/console/search/create_new_search/six_basic_filters'
      )
    }

    if (showPopulation) {
      return (
        <div className={classes.root}>
          <Typography type="body2" color="inherit" className={classes.flex}>
            5. Education
          </Typography>
          <br />
          <Typography>
            You can check the user distribution of the education level by
            tapping the button below:
          </Typography>
          <div className={classes.buttonDistribution}>
            <Button
              raised
              onClick={() =>
                this.props.changeRoute(
                  '/console/search/create_new_search/six_basic_filters/distribution_5'
                )
              }
              color="primary"
              align="center"
              className={classes.button}
            >
              See Distribution
            </Button>
          </div>
          <Typography>Select the minimum education level:</Typography>
          <form className={classes.container} autoComplete="off">
            <FormControl className={classes.youngest}>
              <InputLabel htmlFor="education-rating">
                Education Level
              </InputLabel>
              <Select
                value={this.state.current_level}
                onChange={this.handleChange}
                input={<Input name="education" id="education-rating" />}
              >
                {this.state.levels.map(item => {
                  return <MenuItem value={item}>{item}</MenuItem>
                })}
              </Select>
            </FormControl>
          </form>
          <div className={classes.population}>
            <Typography type="body2">Profiles after filter applied:</Typography>
            <Typography>Population Count: {this.state.popCount}</Typography>
          </div>
          <div className={classes.buttonNext}>
            {this.state.popLoaded && (
              <Button
                raised
                onClick={() => this.onNext()}
                color="primary"
                align="center"
                className={classes.button}
              >
                Next
              </Button>
            )}
            {!this.state.popLoaded && (
              <Button
                disabled
                raised
                onClick={() => this.onNext()}
                color="primary"
                align="center"
                className={classes.button}
              >
                Next
              </Button>
            )}
          </div>
        </div>
      )
    } else {
      return (
        <div className={classes.root}>
          <Typography type="body2" color="inherit" className={classes.flex}>
            5. Education
          </Typography>
          <br />
          <Typography>
            You can check the user distribution of the education level by
            tapping the button below:
          </Typography>
          <div className={classes.buttonDistribution}>
            <Button
              raised
              onClick={() =>
                this.props.changeRoute(
                  '/console/search/create_new_search/six_basic_filters/distribution_5'
                )
              }
              color="primary"
              align="center"
              className={classes.button}
            >
              See Distribution
            </Button>
          </div>
          <Typography>Select the minimum education level:</Typography>
          <form className={classes.container} autoComplete="off">
            <FormControl className={classes.youngest}>
              <InputLabel htmlFor="education-rating">
                Education Level
              </InputLabel>
              <Select
                value={this.state.current_level}
                onChange={this.handleChange}
                input={<Input name="education" id="education-rating" />}
              >
                {this.state.levels.map(item => {
                  return <MenuItem value={item}>{item}</MenuItem>
                })}
              </Select>
            </FormControl>
          </form>
          <div className={classes.buttonNext}>
            <Button
              raised
              onClick={() => this.onShowPopulation()}
              color="primary"
              align="center"
              className={classes.button}
            >
              Apply Filter
            </Button>
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    step: state.step.step,
    agelow: state.age.low,
    agehigh: state.age.high,
    oarlow: state.oar.low,
    oarhigh: state.oar.high,
    education: state.education.education,
    income: state.income.income,
    old_age: state.old_age,
    pref_fans: state.pref_fans
  }
}

function matchDispatchToProps(dispatch) {
  return {
    saveStep: bindActionCreators(saveStep, dispatch),
    save_Education_Data: bindActionCreators(save_Education_Data, dispatch),
    savePopCount: bindActionCreators(savePopCount, dispatch),
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(Question5)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Question5/index.js